import { useState } from 'react';

import { Button } from '@@/buttons';

interface Props {
  children: string;
  maxLength?: number;
}

export function ExpandableMessage({ children, maxLength = 60 }: Props) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (children.length <= maxLength) {
    return <span>{children}</span>;
  }

  return (
    <div className="flex flex-col items-start">
      <span>
        {isExpanded ? children : `${children.substring(0, maxLength)}...`}
      </span>
      <Button
        color="link"
        size="xsmall"
        onClick={() => setIsExpanded(!isExpanded)}
        className="!ml-0 !p-0"
        data-cy="expandable-message-button"
      >
        {isExpanded ? 'Show less' : 'Show more'}
      </Button>
    </div>
  );
}
